export const LANGUAGE_OPTIONS = ['system', 'zh-CN', 'en']

export function normalizeLanguage (language) {
  return LANGUAGE_OPTIONS.includes(language) ? language : 'system'
}

export function resolveLanguage (preference, systemLanguage) {
  if (preference === 'zh-CN' || preference === 'en') return preference
  return /^zh(?:-|$)/i.test(systemLanguage || '') ? 'zh-CN' : 'en'
}

export function getSystemLanguage () {
  return typeof navigator === 'undefined' ? 'en' : navigator.language || (navigator.languages || [])[0] || 'en'
}
